import React from 'react'
import $ from 'jquery'

function OrdersPage() {
    let form_active = false;

    function agree_button(event){
        form_active = true;
        if(form_active){
            $('.orders_section_inner_wrapper').addClass('disable');
            $('.orders_form_inner_wrapper').removeClass('disable');
        } else {
            $('.orders_section_inner_wrapper').removeClass('disable');
            $('.orders_form_inner_wrapper').addClass('disable');
        }
    }

    function radio_1(event){
        $('.form_section_1 #radio_2').prop('checked', false);
        $('.orders_form_inner_wrapper .form_section_2').addClass('disable')
        $('.form_section_4 .input_6').addClass('disable');
    };

    function radio_2(event){
        $('.form_section_1 #radio_1').prop('checked', false);
        $('.orders_form_inner_wrapper .form_section_2').removeClass('disable')
        $('.form_section_4 .input_6').removeClass('disable');

    };

    function radio_3(event){
        $('.form_section_2 #radio_4').prop('checked', false);
    };

    function radio_4(event){
        $('.form_section_2 #radio_3').prop('checked', false);

    };    

  return (
    <main>

        <div className="news_title_section">
            <h2>SARGYTLAR</h2>
            <img src={require("./static/img/element1.png")} className="" alt="" />
        </div>


        <div className="orders_section">
            <img src={require("./static/img/element3.png")} alt="" />
            <div className="orders_section_inner_wrapper">
                <div className="orders_section_title">
                    <h2>Üns beriň!</h2>
                </div>
                <div className="orders_section_content">
                    <h3>Edara-kärhanalaryň we raýatlaryň dykgatyna!</h3>
                    <p>"Maryawtoulag" önümçilik birleşigi edara-kärhanalara, raýatlara we býujetden maliýeleşdirilýän kärhanalara awtoulag hyzmatlaryny ýerine ýetirýär.</p>
                    <h3>Bellik:</h3>
                    <ul>
                        <li>sargytlar azyndan 24 sagat öňünden edilmelidir;</li>
                        <li>awtoulagyň garaždan çykyp sargyt edilen ýere çenli we sargydy tamamlap garaža çenli geçen aralygy üçin goşmaça töleg alynýar;</li>
                        <li>sargyt üçin tölegler öňünden alynýar.</li>
                    </ul>
                    <div className="agree_button" onClick={agree_button}>
                        <a>Tanyşdym</a>
                    </div>
                </div>
            </div>

            <div className="orders_form_inner_wrapper disable">
                <form action="">
                    <div className="form_section_1">
                        <div className="button_1">
                            <input type="radio" name="radio_1" id="radio_1" checked="true" onClick={radio_1} />
                            <label htmlFor="radio_1">Fiziki şahs</label>
                        </div>
                        <div className="button_2">
                            <input type="radio" name="radio_2" id="radio_2" onClick={radio_2} />
                            <label htmlFor="radio_2">Ýuridiki şahs</label>
                        </div>
                    </div>

                    <div className="form_section_2 disable">
                        <div className="button_1">
                            <input type="radio" name="radio_3" id="radio_3" checked="true" onClick={radio_3} />
                            <label htmlFor="radio_3">Býujete degişli edara</label>
                        </div>
                        <div className="button_2">
                            <input type="radio" name="radio_4" id="radio_4" onClick={radio_4} />
                            <label htmlFor="radio_4">Býujete degişli däl edara</label>
                        </div>
                    </div>
                    <hr />

                    <div className="form_section_3">
                        <div className="input_1">
                            <label htmlFor="name">Adyňyz</label>
                            <input type="text" name="name" id="name" />
                        </div>
                        <div className="input_2">
                            <label htmlFor="tel_number">Telefon belgiňiz</label>
                            <input type="text" name="tel_number" id="tel_number" />
                        </div>
                        <div className="input_3">
                            <label htmlFor="email">E-mail</label>
                            <input type="text" id="email" name="email" />
                        </div>
                    </div>
                    <hr />

                    <div className="form_section_4">
                        <div className="input_1">
                            <label htmlFor="date">Senesi</label>
                            <input type="text" name="date" id="date" />
                        </div>
                        <div className="input_2">
                            <label htmlFor="starting_point">Ulagyň ugramaly ýeri</label>
                            <input type="text" name="starting_point" id="starting_point" />
                        </div>
                        <div className="input_3">
                            <label htmlFor="number_of_passengers">Adam sany</label>
                            <input type="text" id="number_of_passengers" name="number_of_passengers" />
                        </div>
                        <div className="input_4">
                            <label htmlFor="arrival_time">Ulagyň barmaly sagady</label>
                            <input type="text" name="arrival_time" id="arrival_time" />
                        </div>
                        <div className="input_5">
                            <label htmlFor="destination">Ulagyň barmaly ýeri</label>
                            <input type="text" name="destination" id="destination" />
                        </div>
                        <div className="input_6 disable">
                            <label htmlFor="payment_docs">Töleg üçin resminama girizmek</label>
                            <input type="file" id="payment_docs" name="payment_docs" />
                        </div>
                    </div>
                    <hr />

                    <div className="form_section_5">
                        <div className="textarea_wrapper">
                            <label htmlFor="note">Bellik</label>
                            <textarea name="note" id="note"></textarea>
                        </div>
                    </div>
                    <div className="send_button">
                        <button type="submit">Ugrat</button>
                    </div>
                </form>
            </div>
        </div>

        

    </main>
  )
}

export default OrdersPage